import { Icon as Icons, Grid } from '@material-ui/core'
import { colors } from 'shared/styles/colors'
import styled from 'styled-components'

interface ItemContainerProps {
  margin?: number
}

export const Container = styled.div`
  display: flex;
  min-height: 156px;
  padding: 10px;
  width: 100%;
  background-color: ${colors.white};
  border: 1px solid ${colors.blue};
  border-radius: 8px;
`
export const Title = styled.span`
  color: #999999;
  font-size: 13px;
  line-height: 15px;
`
export const Subtitle = styled.span`
  color: #000000;
  font-size: 15px;
  font-weight: 900;
  line-height: 15px;
  text-transform: capitalize;
  padding-top: 2px;
`
export const Icon = styled(Icons)`
  color: ${colors.blue};
  display: flex;
  align-items: center;
`

export const CardContainer = styled.div`
  max-width: 450px;
`

export const GridContainer = styled(Grid)`
  padding: 5px 0;
`
export const IconProduto = styled.img`
  src: ${props => props.src};
  color: ${colors.blue};
  width: 16px;
  height: 16px;
  margin-right: 5px;
`

export const ItemContainer = styled.div<ItemContainerProps>`
  margin-bottom: ${props => (props.margin ? props.margin : 17)}px;
`

export const TagProduto = styled.span`
  color: #ffff;
  font-size: 12px;
  font-weight: 500;
  background-color: #999999;
  border-radius: 50px;
  padding: 3px 8px;
  text-transform: capitalize;
`
export const IconLoteDirecionadoCard = styled.img`
  position: absolute;
  float: left;
  width: 50px;
  top: -7px;
  left: -6px;

  &.hidden {
    display: none;
  }
`
export const Logomarca = styled.div`
  height: 40px;
  margin-top: 5px;
  max-width: 120px;

  img {
    height: 40px;
    max-width: 130px;
  }
`
export const SpanEmpresa = styled.span`
  color: #000000;
  font-size: 12px;
  font-weight: 900;
  line-height: 20px;
  text-transform: capitalize;
`
export const GridCard = styled.div`
  position: relative;

  .card-height {
    max-height: 250px !important;
  }

  .card-button-mt {
    margin-top: 14px !important;
  }

  .card-button {
    background: ${colors.green};
    color: white;
    margin-top: 8px;
    height: 37px !important;

    .MuiButton-startIcon {
      margin-top: -3px;
    }

    .MuiButton-label {
      text-transform: none;
    }

    :hover {
      background: ${colors.greenDark};
    }
  }

  @media screen and (max-height: 900px) {
    .card-height {
      height: 250px !important;
      padding: 18px 16px;
    }
  }
`
